/* eslint-disable react-hooks/exhaustive-deps */
/* ============================================================
   ตั้งรหัสผ่านใหม่ตอนเข้าใช้งานครั้งแรก

   เด้งเองอัตโนมัติเมื่อผู้ใช้ที่เพิ่งถูกสร้างเข้าระบบครั้งแรก
   ปิดหน้าต่างทิ้งไม่ได้ ต้องตั้งรหัสผ่านก่อนถึงจะใช้งานต่อได้

   เงื่อนไข : ไม่จำกัดความยาว และใช้รหัสผ่านเดิมซ้ำได้
============================================================ */
import { useEffect, useState } from "react";
import { Modal, Form, Input, Typography, message } from "antd";

import UserService from "../../../service/User.service";

const userService = UserService();

export default function ModalFirstPassword() {
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    userService
      .mustChangePassword()
      .then((res) => {
        if (res?.data?.data?.must_change === "Y") setOpen(true);
      })
      .catch(() => {});
  }, []);

  const handleSave = () => {
    form.validateFields().then((v) => {
      if (v.pwd !== v.pwd2) {
        message.error("รหัสผ่านทั้งสองช่องไม่ตรงกัน");
        return;
      }
      setSaving(true);
      userService
        .setFirstPassword(v.pwd)
        .then((res) => {
          message.success(res?.data?.message || "ตั้งรหัสผ่านใหม่เรียบร้อย");
          form.resetFields();
          setOpen(false);
        })
        .catch((err) =>
          message.error(err?.response?.data?.message || "ตั้งรหัสผ่านไม่สำเร็จ")
        )
        .finally(() => setSaving(false));
    });
  };

  return (
    <Modal
      title="ตั้งรหัสผ่านสำหรับใช้งานครั้งแรก"
      open={open}
      onOk={handleSave}
      okText="บันทึกรหัสผ่าน"
      confirmLoading={saving}
      /* ปิดเองไม่ได้ ต้องตั้งรหัสผ่านก่อน */
      closable={false}
      maskClosable={false}
      keyboard={false}
      cancelButtonProps={{ style: { display: "none" } }}
      width={460}
    >
      <Typography.Paragraph type="secondary" style={{ marginTop: 8 }}>
        เพื่อความปลอดภัย กรุณาตั้งรหัสผ่านของคุณเองก่อนเริ่มใช้งาน
      </Typography.Paragraph>

      <Form form={form} layout="vertical" autoComplete="off">
        <Form.Item
          label="รหัสผ่านใหม่"
          name="pwd"
          rules={[{ required: true, message: "กรุณากรอกรหัสผ่านใหม่" }]}
        >
          <Input.Password placeholder="กรอกรหัสผ่านใหม่" autoFocus />
        </Form.Item>
        <Form.Item
          label="ยืนยันรหัสผ่านใหม่"
          name="pwd2"
          rules={[{ required: true, message: "กรุณากรอกรหัสผ่านอีกครั้ง" }]}
        >
          <Input.Password
            placeholder="กรอกรหัสผ่านอีกครั้ง"
            onPressEnter={handleSave}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
}
